export default class HardwareModel {
    constructor(public name: string, public marking: string, public uuid: string, public version: string) {}

    stateIntRepresentation() {
        return 0;
    }
}
